module.exports = __webpack_public_path__ + "media/images/responsive/costumes/category_icons/kimono/hakama-77bec716eee42562268d20fab3832482.jpg";